import ApiHandler from './ApiHandler'

export default {
  getSalesPerson: () => ApiHandler.get('sales')
}
